module.exports = __webpack_public_path__ + "static/Gilroy-Light-90dc7efad09b994c283884314f633797.woff2";